<script lang="ts">
    import cn from 'classnames';
    import { onMount } from 'svelte';
    import { recaptchaService } from '$lib/services/recaptcha';

    import s from './recaptchaV2.module.css';

    export let captchaWait = false;
    export let isRendered = false;
    export let classes = '';
    export let submit: (token: string) => void;

    const calcIsCaptchaV2Rendered = (_: boolean) => {
        isRendered = recaptchaContainer?.getElementsByTagName('iframe').length > 0;
    };
    $: calcIsCaptchaV2Rendered(captchaWait);

    let recaptchaContainer: HTMLElement;

    export const reset = () => {
        captchaWait = true;
        if (isRendered) {
            recaptchaService.resetRecaptchaV2();
        }
    };

    onMount(() => {
        captchaWait = true;
        recaptchaService.renderRecaptchaV2(recaptchaContainer,
            (token) => {
                submit(token);
                captchaWait = false;
            },
            () => (captchaWait = true)
        );
    });
</script>

<div class={cn(s.root, classes)} bind:this={recaptchaContainer}></div>
